<template>

    <Toast/>

    <div class="px-6 surface-overlay relative">

        <div class="py-3 lg:py-3 px-6 flex align-items-center justify-content-between lg:static">
            <img src="images/blocks/logos/logo.simplyinvesting.rev2.png" alt="Simply Investing" height="50"
                 class="mr-0 lg:mr-6">
        </div>

        <div class="surface-section px-4 py-8 md:px-6 lg:px-8 overflow-hidden">

            <div class="grid">
                <div class="col-12 md:col-12">
                    <div class="card p-fluid">

                        <h2>Forgot Your Password?</h2>

                        <div class="field">
                            <span>Enter your username below. If it matches the information on our application,
                                you'll receive an email to reset the password. Please check your email to complete your password reset.
                            </span>
                        </div>

                        <div class="field">
                            <label for="username">Username</label>
                            <InputText id="username" type="text" :disabled="false" v-model.trim="username"/>
                        </div>

                        <hr class="mb-3 mx-0 border-top-1 border-none surface-border mt-auto"/>

                        <Button
                            label="Reset Password"
                            :disabled="!isFormValid"
                            class="p-3 w-full mt-auto custom-button"
                            :loading="submitted"
                            @click="processResetPassword"
                        />
                    </div>

                </div>
            </div>
        </div>

    </div>

    <SiFooter/>

</template>

<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";

export default {
    components: {SiFooter},
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");
    },
    data() {
        return {
            activeTab: 1,
            submitted: false,
            username: null,
        }
    },
    computed: {
        isFormValid() {
            // Check if all required fields are filled and email is valid
            if (this.username) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        async processResetPassword() {
            this.submitted = true;

            if (this.isFormValid) {

                try {
                    await UserService.resetPassword(this.username);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Successfully sent password reset email.',
                        life: 3000
                    });

                    setTimeout(() => {
                        window.location.href = "/#/siLogin";
                    }, 1000);

                } catch (e) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to send password reset email. Please try again.',
                        life: 3000
                    });

                    setTimeout(() => {
                        window.location.href = "/#/siLogin";
                    }, 1000);
                }
            }

            this.submitted = false;
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}

.custom-button {
    background-color: #2E5439; /* Button background color */
    color: white; /* Button text color */
    border: none; /* Remove border if needed */
}

.custom-button:hover {
    background-color: #3E6948; /* Slightly lighter shade for hover effect */
}
</style>
